import React from 'react';
import { useTranslation } from 'react-i18next';

import Preloader from 'components/Preloader';
import { TYPE_CURRENCY, TYPE_NUMBER } from 'utils/formatting';
import { OverviewPanel, OverviewItem } from 'components/Overview/index';
import { VALUE_TYPES } from 'components/Overview/Overview.types';
import Card from '../../../components/Card/Card';
import { useManagerProfile } from '../../../prodivers/managerProfile';

const Overview = () => {
    const { t } = useTranslation();

    const {
        isLoading, totalsError, dashboardInfo,
    } = useManagerProfile();

    return (
        <Card>
            <OverviewPanel>
                <Preloader isLoading={isLoading} error={totalsError}>
                    <OverviewItem
                        title={t('advisoryDashboard.overview.totalAUM')}
                        type={TYPE_CURRENCY as VALUE_TYPES}
                        value={dashboardInfo?.totalAssets}
                        icon="total-aum"
                    />
                    <OverviewItem
                        title={t('advisoryDashboard.overview.depotsNumber')}
                        type={TYPE_NUMBER as VALUE_TYPES}
                        value={dashboardInfo?.numberOfDeposits}
                        icon="clients"
                    />
                    <OverviewItem
                        title={t('advisoryDashboard.overview.clients')}
                        itemLink="/clients"
                        type={TYPE_NUMBER as VALUE_TYPES}
                        value={dashboardInfo?.numberOfCustomers}
                        icon="clients"
                    />
                </Preloader>
            </OverviewPanel>
        </Card>
    );
};

export default React.memo(Overview);
